import { CheckCircle, Circle } from "@untitledui/icons";
import type { ReactNode } from "react";
import { ButtonGroupItem } from "@/components/base/button-group/button-group";

interface FilterToggleItemProps {
  id: string;
  children: ReactNode;
}

const selectedClass =
  "selected:bg-gray-blue-100 selected:text-gray-blue-700 selected:hover:bg-gray-blue-200 selected:hover:text-gray-blue-700 selected:ring-gray-blue-300";

export const FilterToggleItem = ({ id, children }: FilterToggleItemProps) => {
  return (
    <ButtonGroupItem id={id} className={selectedClass}>
      {({ isSelected }) => (
        <>
          {isSelected ? (
            <CheckCircle className="size-4 text-gray-blue-700" />
          ) : (
            <Circle className="size-4 text-tertiary" />
          )}
          {children}
        </>
      )}
    </ButtonGroupItem>
  );
};
